import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { Share } from '@/components/Share/Share';
import { EntityType, Hcphco } from '@/core/graphql/generated/types';

import { DcrControl } from '../DcrControl/DcrControl';
import { ReactivateDcrControl } from '../ReactivateDcrControl/ReactivateDcrControl';

import { profilePageHeaderStyles as sx } from './ProfilePageHeader.styles';

type Props = {
	profile: Hcphco | null;
	loading: boolean;
};

export const ProfilePageHeader = ({ profile, loading }: Props) => {
	const { t } = useTranslation();
	const entityType =
		profile?.__typename === 'HCP' ? EntityType.Hcp : EntityType.Hco;

	return (
		<Box sx={sx.headerRow}>
			<Typography sx={sx.typeLabel} variant='body1'>
				{profile?.__typename === 'HCP' ? t('HCP') : t('HCO')}
			</Typography>

			<Box sx={sx.headerActions}>
				{profile && profile?.statusCda_VId !== 'iact' && (
					<DcrControl loading={loading} entityType={entityType} />
				)}

				{profile && profile?.statusCda_VId === 'iact' && (
					<ReactivateDcrControl profile={profile} entityType={entityType} />
				)}

				<Share
					title={t('Share this profile')}
					collapseAt='lg'
					description={t(
						'Copy and paste the link above to share this profile.'
					)}
				/>
			</Box>
		</Box>
	);
};
